<template>
  <Dropdown class="language-switch-dropdown" trigger="click">
    <slot />
    <DropdownMenu slot="list">
      <DropdownItem
        v-for="key in languages"
        :key="key"
        @click.native="onChangLang(key)"
      >
        {{ $t(`language.${key}`) }}
      </DropdownItem>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import {
  localeKeys,
  localeKeyToValueMap
} from '@/assets/js/multilingual-tools';
import { AuthManage } from '@/plugins/auth';

export default {
  props: {
    remote: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    languages() {
      return _.filter(localeKeys, (v) => v !== this.$i18n.locale);
    }
  },
  methods: {
    async onChangLang(key) {
      if (AuthManage && AuthManage.token) {
        localStorage.setItem('i18n', key);
        document.body.className =
          this.$i18n.locale === 'en' ? 'en-font' : 'hk-font';

        window.localStorage.setItem('switchLanguage', true);
        await this.$http(
          'post',
          'mobile/user_language',
          { language: localeKeyToValueMap[key] },
          false
        );
        setTimeout(() => {
          location.reload();
        }, 100);
      } else {
        this.$emit('on-change', key);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.language-switch-dropdown {
  /deep/.ivu-dropdown-rel {
    cursor: pointer;
  }
}
</style>
